import React from 'react';

import ens from './images/ens.png';
import opensea from './images/opensea.svg';
import rarible from './images/rarible.svg';

import './Card.scss';

export interface IconContainer {
  [key: string]: any;
}

export const Icons: IconContainer = {
  opensea,
  rarible,
  ens,
};

interface CardProps {
  name: string;
  icon: string;
}

export function Card(props: CardProps) {
  return (
    <div className="card">
      <img src={Icons[props.icon]} />
      <div className="name">{props.name}</div>
    </div>
  );
}
